import {makeStyles} from "@material-ui/core/styles";
import {
    FILTER_STATUS_ALL,
    FILTER_STATUS_CLOSED,
    FILTER_STATUS_PENDING,
} from "../Po/constants";

export const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        marginBottom: 30
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    select: {
        height: 50, width: 500
    }
}));

export const initialState = {
    user: 'you',
    state: FILTER_STATUS_PENDING.toLowerCase()
}

export const orderStates = [
    {value: FILTER_STATUS_CLOSED.toLowerCase(), label: "Fait"},
    {value: FILTER_STATUS_PENDING.toLowerCase(), label: "En cour"},

]

export const states = [
    ...orderStates,
    {value: FILTER_STATUS_ALL.toLowerCase(), label: "Tout"},
]

export const statusColors = (status) => {
    switch (status.toLowerCase()) {
        case FILTER_STATUS_PENDING.toLowerCase():
            return 'orange';
        case FILTER_STATUS_CLOSED.toLowerCase():
            return 'green';
        default :
            return 'white'
    }
}

